export default __webpack_public_path__ + "LS-dark-(2).svg";